<template>
    <v-row class="ddblack py-6 ma-6" justify="center" align="center">
        <v-col cols="auto" class="text-center">
            <v-img src="/select-location.png" min-width="200" max-width="300"/>
        </v-col>
        <v-col cols="auto" class="my-6 py-6">
            <span class="text-h5 font-weight-light">{{ $t('components.EmptyDashboard.Message') }}</span>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: 'EmptyDashboard'
}
</script>

